import { render, staticRenderFns } from "./datepicker.vue?vue&type=template&id=5711eb4f&scoped=true"
import script from "./datepicker.vue?vue&type=script&lang=js"
export * from "./datepicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5711eb4f",
  null
  
)

export default component.exports